var React = require('react');

function IconPause (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-60 -632)"},React.createElement("g",{"transform":"translate(60 617)"},React.createElement("g",{"transform":"translate(0 11)"},React.createElement("g",null,React.createElement("g",{"transform":"translate(0 4)"},[React.createElement("path",{"d":"M512.58 98.23C283.5 98.23 98 284.14 98 513.22s185.5 415 414.58 415c229.49 0 415.41-185.92 415.41-415S742.08 98.23 512.58 98.23zm.42 760.82c-191.07 0-345.83-154.76-345.83-345.83S321.93 167.39 513 167.39s345.83 154.76 345.83 345.83S704.07 859.05 513 859.05z","key":0}),React.createElement("path",{"d":"M374.67 328.78h92.22v415h-92.22z","key":1}),React.createElement("path",{"d":"M559.11 328.78h92.22v415h-92.22z","key":2})]))))));
}

IconPause.displayName = "IconPause";

IconPause.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconPause;

IconPause.default = IconPause;
